import styled, { keyframes } from 'styled-components';
import { getStyles } from '../../utils/getStyles/getStyles';
const breatheAnimation = keyframes `
  to {
    background-position-x: -200%;
  }
`;
export const SkeletonStyled = styled.div `
  ${props => getStyles(props.styles?.skeleton)}
  width: ${props => props.$width};
  height: ${props => props.$height};
  animation-name: ${breatheAnimation};
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: ${props => props.duration};
  animation-delay: 1ms;
`;
//# sourceMappingURL=skeleton.styled.js.map